<!-- components/ImageGallery.vue -->
<template>
  <div class="container mx-auto px-4 py-8">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
      <div
        v-for="image in displayedImages"
        :key="image"
        class="overflow-hidden rounded-lg shadow-lg"
      >
        <img
          :src="`${baseUrl}${image}`"
          :alt="image"
          class="w-full h-[400px] object-cover transition-transform duration-300 hover:scale-105"
        />
      </div>
    </div>

    <!-- Loading indicator -->
    <div
      v-if="loading"
      class="flex justify-center items-center my-8"
    >
      <div class="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
    </div>

    <!-- Observer element for infinite scroll -->
    <div ref="observer" class="h-4 w-full"></div>
  </div>
</template>

<script>
export default {
  name: 'ImageGallery',
  props: {
    images: {
      type: Array,
      required: true
    },
    baseUrl: {
      type: String,
      default: 'https://res.cloudinary.com/diyapvgve/image/upload/'
    },
    perPage: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      displayedImages: [],
      page: 0,
      loading: false,
      observer: null
    }
  },
  mounted() {
    this.loadMoreImages()

    // Set up intersection observer for infinite scroll
    this.observer = new IntersectionObserver(this.handleIntersect, {
      rootMargin: '0px 0px 200px 0px' // Start loading when user is 200px from bottom
    })

    if (this.$refs.observer) {
      this.observer.observe(this.$refs.observer)
    }
  },
  beforeUnmount() {
    // Clean up observer
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    loadMoreImages() {
      this.loading = true

      // Simulate loading delay (remove in production)
      setTimeout(() => {
        const start = this.page * this.perPage
        const end = start + this.perPage
        const newImages = this.images.slice(start, end)

        if (newImages.length > 0) {
          this.displayedImages = [...this.displayedImages, ...newImages]
          this.page += 1
        }

        this.loading = false
      }, 500)
    },
    handleIntersect(entries) {
      if (entries[0].isIntersecting && !this.loading) {
        // Only load more if we haven't loaded all images yet
        if (this.displayedImages.length < this.images.length) {
          this.loadMoreImages()
        }
      }
    }
  }
}
</script>